import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c3424dc6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container-wrap"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "一流课程"), /*#__PURE__*/_createElementVNode("div", {
  class: "solid-line"
}, [/*#__PURE__*/_createElementVNode("span")]), /*#__PURE__*/_createElementVNode("div", {
  class: "dash-line"
}, [/*#__PURE__*/_createElementVNode("span")])])], -1));

const _hoisted_3 = {
  class: "course-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "course-card"
};
const _hoisted_6 = {
  class: "course-card_info"
};
const _hoisted_7 = {
  class: "major-name"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line1"
}, null, -1));

const _hoisted_10 = {
  class: "school-name"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/bcad8967fbd24064b3e122a12cbf5175.png",
  width: "20"
}, null, -1));

const _hoisted_12 = {
  class: "course-type"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_15 = [_hoisted_13, _hoisted_14];
import { ref } from 'vue';
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const courseList = ref([]);

    const getCourseList = async () => {
      let params = {
        menu_id: props.menu.menu_id,
        num: props.menu.num
      };
      const res = await $http.getHomeMooc(params);
      courseList.value = res;
    };

    getCourseList();

    const goToDetails = url => {
      window.open(url, '_blank');
    };

    const loadingMore = () => {
      window.open('http://cpu.fy.chaoxing.com/', '_blank');
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: $event => goToDetails(item.course_url),
          style: _normalizeStyle({
            backgroundImage: 'url(' + item.course_cover_url + ')'
          })
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(item.course_name), 1), _hoisted_8, _hoisted_9, _createElementVNode("p", _hoisted_10, [_hoisted_11, _createTextVNode(_toDisplayString(item.organ_name), 1)]), _createElementVNode("p", _hoisted_12, "主讲老师：" + _toDisplayString(item.lecturer), 1)])])], 12, _hoisted_4);
      }), 128))]), _createElementVNode("div", {
        class: "loadMore",
        onClick: loadingMore
      }, _hoisted_15)])]);
    };
  }

};